import React from 'react';
import { Breadcrumb } from 'antd';

const Trail = ({ currentPath, onNavigate }) => {
  const pathParts = currentPath.split('/').filter(Boolean);

  return (
    <Breadcrumb>
      <Breadcrumb.Item onClick={() => onNavigate('')}>Home</Breadcrumb.Item>
      {pathParts.map((part, index) => (
        <Breadcrumb.Item
          key={index}
          onClick={() => onNavigate(pathParts.slice(0, index + 1).join('/'))}
        >
          {part}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Trail;
